import React from "react"
import { Link } from "gatsby"

export const Author = ({ author, ...props }) => {
  return (
    <Link
      aria-label={`visit ${author?.name} page`}
      to={`/author/${author?.slug}`}
      {...props}
    >
      {author?.name || ""}
    </Link>
  )
}
